import React, { Component } from 'react';
import moment from 'moment';
import { FormattedMessage, FormattedDate } from 'react-intl';
import messages from '../fileViewerMessages';
import FormattedDateShort from '../../FormattedDateShort';

class EidViewer extends Component {
  parseEid = xml => {
    try {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xml, 'text/xml');
      const identity = xmlDoc.getElementsByTagName('identity')[0];

      const cardInformation = {};

      cardInformation.lastName = identity.getElementsByTagName('name')[0].childNodes[0].nodeValue;
      cardInformation.firstName = identity.getElementsByTagName(
        'firstname',
      )[0].childNodes[0].nodeValue;
      cardInformation.nationality = identity.getElementsByTagName(
        'nationality',
      )[0].childNodes[0].nodeValue;
      cardInformation.placeOfBirth = identity.getElementsByTagName(
        'placeofbirth',
      )[0].childNodes[0].nodeValue;
      cardInformation.nationalNumber = identity.getAttribute('nationalnumber');
      cardInformation.gender = identity.getAttribute('gender');
      cardInformation.dateOfBirth = moment(identity.getAttribute('dateofbirth')).toDate();
      cardInformation.cardNumber = xmlDoc
        .getElementsByTagName('card')[0]
        .getAttribute('cardnumber');
      cardInformation.cardExpiryDate = moment(
        xmlDoc.getElementsByTagName('card')[0].getAttribute('validitydateend'),
      ).toDate();
      cardInformation.street = xmlDoc
        .getElementsByTagName('address')[0]
        .getElementsByTagName('streetandnumber')[0].childNodes[0].nodeValue;
      cardInformation.zip = xmlDoc
        .getElementsByTagName('address')[0]
        .getElementsByTagName('zip')[0].childNodes[0].nodeValue;
      cardInformation.city = xmlDoc
        .getElementsByTagName('address')[0]
        .getElementsByTagName('municipality')[0].childNodes[0].nodeValue;
      cardInformation.photo = identity.getElementsByTagName('photo')[0].childNodes[0].nodeValue;
      return cardInformation;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  render() {
    const { data } = this.props;
    const cardInformation = this.parseEid(data);
    // console.log(cardInformation);

    if (!cardInformation) {
      return <FormattedMessage {...messages.NoPreviewAvailableForThisDocument} />;
    }

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-4">
            <img
              src={`data:image/jpeg;base64,${cardInformation.photo}`}
              style={{ width: '140px', height: '200px' }}
            />
          </div>
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-4 ">
                <strong>
                  <span>
                    <FormattedMessage {...messages.FirstName} />
                  </span>
                </strong>
              </div>
              <div className="col-md-8">
                <label>{cardInformation.firstName}</label>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <strong>
                  <span>
                    <FormattedMessage {...messages.LastName} />
                  </span>
                </strong>
              </div>
              <div className="col-md-8">
                <label>{cardInformation.lastName}</label>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <strong>
                  <span>
                    <FormattedMessage {...messages.DateOfBirth} />
                  </span>
                </strong>
              </div>
              <div className="col-md-8">
                <label>
                  <FormattedDateShort value={cardInformation.dateOfBirth} />
                </label>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <strong>
                  <span>
                    <FormattedMessage {...messages.Nationality} />
                  </span>
                </strong>
              </div>
              <div className="col-md-8">
                <label>{cardInformation.nationality}</label>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <strong>
                  <span>
                    <FormattedMessage {...messages.Gender} />
                  </span>
                </strong>
              </div>
              <div className="col-md-8">
                {cardInformation.gender === 'male' && (
                  <label>
                    <FormattedMessage {...messages.Male} />
                  </label>
                )}
                {cardInformation.gender === 'female' && (
                  <label>
                    <FormattedMessage {...messages.Female} />
                  </label>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <strong>
                  <span>
                    <FormattedMessage {...messages.PlaceOfBirth} />
                  </span>
                </strong>
              </div>
              <div className="col-md-8">
                <label>{cardInformation.placeOfBirth}</label>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <strong>
                  <span>
                    <FormattedMessage {...messages.NationalNumber} />
                  </span>
                </strong>
              </div>
              <div className="col-md-8">
                <label>{cardInformation.nationalNumber}</label>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <strong>
                  <span>
                    <FormattedMessage {...messages.ExpiryDate} />
                  </span>
                </strong>
              </div>
              <div className="col-md-8">
                <FormattedDateShort value={cardInformation.cardExpiryDate} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <strong>
                  <span>
                    <FormattedMessage {...messages.Address} />
                  </span>
                </strong>
              </div>
              <div className="col-md-8">
                <label>{cardInformation.street}</label>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">&nbsp;</div>
              <div className="col-md-8">
                <label>{cardInformation.zip}</label>
                &nbsp;
                <label>{cardInformation.city}</label>
                &nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EidViewer;
